export const getPage = (url = window.location.pathname) => {
  const urlQueryRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
  const urlParts = url.split('/');
  const possibleUUIDPart = urlParts[urlParts.length - 1];
  return (urlQueryRegex.test(possibleUUIDPart)
    ? url.replace(`/${possibleUUIDPart}`, '')
    : url).replace('#', '');
};
